import { ContactForm } from "../types/ContactForm";
import { ApiService } from "./ApiService";
import Cookies from "js-cookie";
import { RateAgreementFormData } from "../types/RateAgreementFormData";
import { readLanguageFromCookie } from "../utils/helper";

const baseUrl = "/services/contactform/api/contactform";
const XSRF_TOKEN_COOKIE_NAME = "XSRF-TOKEN";
class ContactFormService extends ApiService {
    async createContactForm(contactForm: ContactForm, rateAgreementFormData?: RateAgreementFormData) {
        contactForm.language = readLanguageFromCookie();

        const response = await fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-XSRF-TOKEN": Cookies.get(XSRF_TOKEN_COOKIE_NAME) as string,
            },
            body: JSON.stringify({ ...contactForm, rateAgreementForm: rateAgreementFormData }),
        });
        await this.handleResponse(response);
    }

    async getTopicTypes(): Promise<string[]> {
        const response = await fetch(baseUrl + "/topic", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const result = await this.handleResponse(response);
        return result.json();
    }

    async getDebtNo() {
        const response = await fetch(baseUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const debtNo = await this.handleResponse(response);
        return debtNo.text();
    }
}

export default new ContactFormService();
